import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { S3Image } from "aws-amplify-react";
import classNames from "classnames";

import styles from "./cardStyle-jss";
import { getUrlImage } from "../../service/s3Amplify";

const validateUrl = value =>
  value && /^(ftp|http|https):\/\/[^ "]+$/.test(value) ? "Invalid" : undefined;

class NewsCard extends React.Component {
  _isMounted = false;

  state = {
    url: "",
    attachmentUrl: ""
  };

  componentWillReceiveProps(newProps) {
    // handle image (existing behavior)
    if (!validateUrl(newProps.image)) {
      getUrlImage(newProps.image).then(response => {
        if (this._isMounted) {
          this.setState({ url: response });
        }
      }).catch(() => {
        if (this._isMounted) {
          this.setState({ url: "" });
        }
      });
    } else {
      if (this._isMounted) {
        this.setState({ url: newProps.image });
      }
    }

    // handle attachment (pdf/doc file stored in S3)
    if (newProps.attachment) {
      if (!validateUrl(newProps.attachment)) {
        getUrlImage(newProps.attachment).then(response => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: response });
          }
        }).catch(() => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: "" });
          }
        });
      } else {
        if (this._isMounted) {
          this.setState({ attachmentUrl: newProps.attachment });
        }
      }
    } else {
      if (this._isMounted) {
        this.setState({ attachmentUrl: "" });
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;
    // initialize attachmentUrl on mount
    const { image, attachment } = this.props;
    if (image) {
      if (!validateUrl(image)) {
        getUrlImage(image).then(response => {
          if (this._isMounted) {
            this.setState({ url: response });
          }
        }).catch(() => { });
      } else {
        this.setState({ url: image });
      }
    }
    if (attachment) {
      if (!validateUrl(attachment)) {
        getUrlImage(attachment).then(response => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: response });
          }
        }).catch(() => { });
      } else {
        this.setState({ attachmentUrl: attachment });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getFilenameFromKey(key) {
    try {
      const parts = key.split('/');
      return parts[parts.length - 1];
    } catch (e) {
      return 'file';
    }
  }

  handleRead = (e) => {
    e && e.preventDefault && e.preventDefault();
    const { attachmentUrl } = this.state;
    if (!attachmentUrl) return;
    const encodedUrl = encodeURIComponent(attachmentUrl);
    const newWindow = window.open(`https://docs.google.com/gview?embedded=true&url=${encodedUrl}`,'_blank','noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  }

  handleDownload = async (e) => {
    e && e.preventDefault && e.preventDefault();
    const { attachmentUrl } = this.state;
    const { attachment } = this.props;
    if (!attachmentUrl) return;
    try {
      // fetch the file to ensure browsers trigger a download even for signed URLs
      const response = await fetch(attachmentUrl);
      if (!response.ok) {
        throw new Error('Download failed');
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = this.getFilenameFromKey(attachment || attachmentUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // fallback: open in new tab if direct download fails
      const fallbackWindow = window.open(attachmentUrl, '_blank', 'noopener,noreferrer');
      if (fallbackWindow) {
        fallbackWindow.opener = null;
      }
    }
  }

  getColorTitle(secColor) {
    if (secColor && (secColor.includes("#") && secColor.toLowerCase() != "#ffffff")) {
      return "#FFFFFF"
    } else {
      return this.context.theme.palette.primary.main
    }
  }

  getColorButton(secColor) {
    if (secColor.includes("#")) {
      return secColor
    } else {
      return "#FFFFFF"
    }
  }

  render() {
    const {
      classes,
      title,
      description,
      notes,
      image,
      attachment,
      busqueda,
      publish_date,
      horizontal,
      kicker,
      colorTitle,
      sendEvent
    } = this.props;
    const namekicker = kicker && kicker.split(",")[0];
    const colorkicker = kicker && kicker.split(",")[1];
    return (
      <Card
        className={classNames(
          classes.card,
          classes.cardVertical,
          busqueda && classes.busqueda
        )}
      >
        {image && (
          <div className={classes.mediaCardVertical}>
            <S3Image imgKey={image} className={classes.mediaVertical} />
          </div>
        )}

        <CardContent className={classes.cardContentVertical}>
          <div className={classes.wrapperBaseline}>
            {publish_date && (
              <Typography component="span" className={classes.datePicker}>
                {publish_date} |
              </Typography>
            )}
            {namekicker && (
              <Typography
                className={classes.kickerVertical}
                style={{ color: colorkicker || '#000000' }}
              >
                <i>{namekicker}</i>
              </Typography>
            )}
          </div>

          <Typography className={classes.titleVertical}>
            {title}
          </Typography>

          {description && (
            <Typography component="p" className={image ? classes.descriptionVertical : classes.descriptionVerticalNoImage}>
              <span
                style={{ color: "#000000" }}
                dangerouslySetInnerHTML={{ __html: `${description}` }}
              />
            </Typography>
          )}

          {attachment && notes && (<div className={classes.footerCard}>
            <Button
              onClick={(e) => { this.handleRead(e); if (sendEvent) sendEvent(e); }}
              disabled={!this.state.attachmentUrl}
              className={classNames(classes.colorPrimary, classes.button, classes.buttonVertical)}
            >
              Ver en línea
            </Button>
            <Button
              onClick={(e) => { this.handleDownload(e); }}
              disabled={!this.state.attachmentUrl}
              variant="outlined"
              className={classNames(classes.button, classes.buttonVertical, classes.borderPrimary)}
            >
              Guardar
            </Button>
          </div>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(NewsCard);
